var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{ref:"card",attrs:{"actions":"","search":"","block":"","title":_vm.$tc('app.log', 2),"loading":_vm.loading},on:{"reload":_vm.fetch},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('data-table',{attrs:{"data":_vm.logs,"pages":_vm.pages,"columns":[
        { key: 'created_at', label: 'date', filters: ['date|DD/MM/YYYY'] },
        'description',
      ],"searchable":""},on:{"search":_vm.search,"change-page":_vm.fetch}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }